export default __webpack_public_path__ + "static/media/datadyst-logo-english.83737aeb.svg";